exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n.wk-table-items th {\n  line-height: initial;\n}\n.wk-table-items .wk-form-item {\n  padding: 8px 0 !important;\n  margin-bottom: 0 !important;\n  width: auto !important;\n}\n.wk-table-items .wk-form-item .el-form-item__label {\n    display: none;\n}\n", ""]);

// exports
exports.locals = {
	"xrColorPrimary": "#2362FB"
};